import { START_AUTOSTREAM as SOCKET_START_AUTOSTREAM} from '../../events/DashboardToServer'
import { STOP_AUTOSTREAM as SOCKET_STOP_AUTOSTREAM} from '../../events/DashboardToServer'

export const AUTOSTREAM_STARTED = 'AUTOSTREAM_STARTED'
export const AUTOSTREAM_STOPPED = 'AUTOSTREAM_STOPPED'
export const START_AUTOSTREAM = 'START_AUTOSTREAM'
export const STOP_AUTOSTREAM = 'STOP_AUTOSTREAM'

export const autostream = (state = false, action) => {
    switch (action.type) {
        case AUTOSTREAM_STARTED:
            return true
    
        case AUTOSTREAM_STOPPED:
            return false

        default:
            return state
    }
}

export const startAutostream = (socket, camera, microphone) => {
    socket.emit(SOCKET_START_AUTOSTREAM, {camera, microphone})
    return { type: START_AUTOSTREAM}
}

export const stopAutostream = (socket) => {
    socket.emit(SOCKET_STOP_AUTOSTREAM)
    return { type: STOP_AUTOSTREAM}
}

export const autostreamStarted = () => {
    return { type: AUTOSTREAM_STARTED}
}

export const autostreamStopped = () => {
    return { type: AUTOSTREAM_STOPPED}
}


// WEBPACK FOOTER //
// ./src/reducers/autostream/index.js